import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { routes } from './app.routing';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//Import Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

import { FilterPipe } from './pipe/filter.pipe';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterModule } from '@angular/router';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { NgHcaptchaModule } from 'ng-hcaptcha';
import { HttpConfigInterceptor } from './interceptors/http-config.interceptor';
import { AuthInterceptor, AuthModule } from 'angular-auth-oidc-client';
import { SSO } from './shared/enums';

const env = (window as any).__env || {};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ declarations: [AppComponent, BlankComponent, FilterPipe],
    exports: [TablerIconsModule],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RouterModule.forRoot(routes),
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        TablerIconsModule.pick(TablerIcons),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        // TODO: Replate with real site key
        NgHcaptchaModule.forRoot({ siteKey: 'f44e4272-c830-41aa-88aa-c51099a8bd66' }),
        NgScrollbarModule,
        FullComponent,
        AuthModule.forRoot({
            config: [
                {
                    configId: SSO.GOOGLE,
                    authority: 'https://accounts.google.com',
                    redirectUrl: `${window.location.origin}/login`,
                    clientId: '931530771145-ee3f6u54ssf8dbfim8dvuj0u0hjfbr2l.apps.googleusercontent.com',
                    responseType: 'id_token token',
                    scope: 'openid profile email',
                    triggerAuthorizationResultEvent: true,
                    historyCleanupOff: true,
                    customParamsAuthRequest: {
                        prompt: 'select_account'
                    },
                    autoUserInfo: false
                },
                {
                    configId: SSO.MICROSOFT,
                    authority: 'https://login.microsoftonline.com/common/v2.0',
                    redirectUrl: `${window.location.origin}/login`,
                    clientId: '33762caa-062b-42e9-99ea-21cdebe172ae',
                    responseType: 'code',
                    scope: 'openid profile email',
                    triggerAuthorizationResultEvent: true,
                    historyCleanupOff: true,
                    ignoreNonceAfterRefresh: true,
                    customParamsAuthRequest: {
                        prompt: 'select_account'
                    },
                    disableIdTokenValidation: true,
                    autoUserInfo: false
                },
                {
                    configId: SSO.IDPORTEN,
                    authority: env.idPortenAuthority,
                    redirectUrl: `${window.location.origin}/login`,
                    clientId: env.idPortenClientId,
                    responseType: 'code',
                    scope: 'openid profile',
                    triggerAuthorizationResultEvent: true,
                    historyCleanupOff: true,
                    ignoreNonceAfterRefresh: true,
                    disableIdTokenValidation: true,
                    autoUserInfo: false,
                    customParamsAuthRequest: {
                        prompt: 'select_account'
                    }
                },
                {
                    configId: SSO.VERIFY_IDPORTEN,
                    authority: env.idPortenAuthority,
                    redirectUrl: `${window.location.origin}/profile`,
                    clientId: env.idPortenClientId,
                    responseType: 'code',
                    scope: 'openid profile',
                    triggerAuthorizationResultEvent: true,
                    historyCleanupOff: true,
                    ignoreNonceAfterRefresh: true,
                    disableIdTokenValidation: true,
                    autoUserInfo: false,
                    customParamsAuthRequest: {
                        prompt: 'select_account'
                    }
                }
            ]
        })], providers: [
        provideHotToastConfig(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
